<template>
  <v-list>
    <v-list-tile
      v-for="(print, index) in prints"
      :key="index"
    >
      <v-list-tile-content>
        {{ print.user.firstName }} {{ print.user.lastName }}
      </v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ formatDate(print.createdAt) }}
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>

import moment from 'moment'

export default {
  name: 'print-list',
  props: {
    prints: Array,
  },
  methods: {
    formatDate(date) {
      return moment(new Date(date)).format('LLL')
    },
  },
}
</script>

<style scoped>

</style>
